import { isMobile } from 'react-device-detect'
import { DesktopNavigation, MobileNavigation } from './DeviceNavigationComponent'

interface NavbarNavigationProps {
   navigateTo: (path: string) => void
   anchorEl: HTMLElement | null
   open: boolean
   handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
   handleClose: () => void
}

const NavbarNavigation: React.FC<NavbarNavigationProps> = ({
   navigateTo,
   anchorEl,
   open,
   handleClick,
   handleClose,
}) => {
   return isMobile ? (
      <MobileNavigation
         navigateTo={navigateTo}
         anchorEl={anchorEl}
         open={open}
         handleClick={handleClick}
         handleClose={handleClose}
      />
   ) : (
      <DesktopNavigation navigateTo={navigateTo} />
   )
}

export default NavbarNavigation
